const DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

const localDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const atTime = (date, value) => {
  const [hours, minutes] = String(value || '').split(':').map(Number);
  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
  const result = new Date(date);
  result.setHours(hours, minutes, 0, 0);
  return result;
};

export const resolveHoursForDate = (openingHours, specialHours = [], date = new Date()) => {
  const dateKey = localDateKey(date);
  const special = (specialHours || []).find(entry => {
    const start = entry.startDate || entry.date;
    const end = entry.endDate || entry.date;
    return start && end && start <= dateKey && dateKey <= end;
  });
  if (special) return { ...special, source: 'special', date: dateKey };
  return {
    ...(openingHours?.[DAYS[date.getDay()]] || { closed: true }),
    source: 'weekly',
    date: dateKey
  };
};

export const getTradingWindowForDate = (openingHours, specialHours = [], date = new Date()) => {
  const hours = resolveHoursForDate(openingHours, specialHours, date);
  if (hours.closed || !hours.open || !hours.close) return null;
  const opensAt = atTime(date, hours.open);
  const closesAt = atTime(date, hours.close);
  if (!opensAt || !closesAt) return null;
  if (closesAt <= opensAt) closesAt.setDate(closesAt.getDate() + 1);
  return { ...hours, opensAt, closesAt };
};

export const isStoreOpen = (openingHours, specialHours = [], now = new Date()) => {
  if (!openingHours) return true;
  const previous = new Date(now);
  previous.setDate(previous.getDate() - 1);
  return [previous, now].some(date => {
    const window = getTradingWindowForDate(openingHours, specialHours, date);
    return window && now >= window.opensAt && now < window.closesAt;
  });
};

export const getNextOpenTime = (openingHours, specialHours = [], now = new Date()) => {
  if (!openingHours) return null;
  for (let offset = 0; offset < 367; offset += 1) {
    const date = new Date(now);
    date.setDate(date.getDate() + offset);
    const window = getTradingWindowForDate(openingHours, specialHours, date);
    if (!window || window.opensAt <= now) continue;
    return {
      day: offset === 0 ? 'today' : offset === 1 ? 'tomorrow' : date.toLocaleDateString('en-GB', { weekday: 'long' }),
      time: window.open,
      opensAt: window.opensAt.toISOString()
    };
  }
  return null;
};

